import { ROUTES_APPLICATION_PATH } from "../../../../routes.constants";
import { USER_ROLES } from "../../../../components/components.constants";
import { buildMenu, SECTION_LABELS } from './utils';

export const getGasStationNavigationOptions = (t, tenantContext, userRole, options) => {
  const {
    hasAdjustmentPlan = false,
  } = tenantContext;

  const produto = buildMenu({
    menuName: "Produto",
    route: ROUTES_APPLICATION_PATH.PRODUCTS.BASE_URL,
    icon: "produto",
    sectionDefs: [
      { label: SECTION_LABELS.OPPORTUNITIES, items: [] },
      {
        label: SECTION_LABELS.TRANSACTIONAL,
        items: [
          hasAdjustmentPlan && (userRole === USER_ROLES.TENANT_ADMIN) && {
            pageName: t("purchaseQualityMenu"),
            route: ROUTES_APPLICATION_PATH.PURCHASE_QUALITY.COMPONENT_URL[0],
            icon: "shield",
          },
          hasAdjustmentPlan && {
            pageName: t("openOrders"),
            route: ROUTES_APPLICATION_PATH.ACTIONS.COMPONENT_URL[0],
            icon: "cart",
          },
          hasAdjustmentPlan && {
            pageName: t("ordersHystory"),
            route: ROUTES_APPLICATION_PATH.ACTIONS.COMPONENT_URL[1],
            icon: "cart",
          },
        ],
      },
      {
        label: SECTION_LABELS.DATA,
        items: [
          hasAdjustmentPlan && (userRole !== USER_ROLES.SHOPKEEPER) && {
            pageName: t("purchaseParam"),
            route: ROUTES_APPLICATION_PATH.ACTIONS.COMPONENT_URL[2],
            icon: "cart",
          },
        ],
      },
    ],
    options
  });

  return [produto].filter(Boolean);
};